import Vue from 'vue'
import filters from '../assets/js/filters'
import mixin from '../assets/js/mixin'
// 全局filter
for (let name in filters) {
  Vue.filter(name, filters[name])
}
// mixin
Vue.mixin(mixin)
